export default "__VITE_ASSET__CbtirT0p__"